// extracted by mini-css-extract-plugin
export default {"Subtitle":"ueA38FFb"};